<template>
  <div class="bg-white">
    <div class="relative z-index1 h-full w-full">
      <div class="">
        <CoverPage />
        <About />
        <div class="">
          <Contents />
        </div>
      </div>
    </div>
    <div class="bge3ceff-opa rounded-t-5555">
      <DownloadApp />
      <Footer />
    </div>
  </div>
</template>

<script>
import CoverPage from "./components/CoverPage.vue";
import Contents from "./components/Contents.vue";
import Footer from "../../Footer.vue";
import About from "./components/About.vue";
import DownloadApp from "@/views/home/components/DownloadApp.vue";
export default {
  components: { CoverPage, About, Contents, Footer, DownloadApp },
};
</script>

<style></style>
